import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import { selectAuth } from '@brands/store/selectors/auth';
import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import React from 'react';
import { useParams } from 'react-router-dom';

import CaseActivityContent from './CaseActivityContent';
import styles from './styles.module.scss';

const CaseActivityPage = (): JSX.Element => {
  const { caseId } = useParams<{ caseId: string }>();
  const roleNavigate = useRoleNavigate();
  const { userInfo } = useAppSelector(selectAuth);
  const parsedCaseId = Number(caseId);

  if (!caseId || Number.isNaN(parsedCaseId)) {
    return <NotFoundPage />;
  }

  return (
    <div className={styles.page}>
      <CaseActivityContent
        caseId={parsedCaseId}
        userRole={userInfo?.role?.name}
        onBack={() => roleNavigate(`/consultation-page/${parsedCaseId}`)}
      />
    </div>
  );
};

export default CaseActivityPage;
